import React, { useState } from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  useSortable,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableItem({ id, url, onDelete, onView }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    // <div
    //   ref={setNodeRef}
    //   style={style}
    //   {...attributes}
    //   {...listeners}
    //   className="w-32 h-24 border rounded-lg overflow-hidden shadow cursor-grab"
    // >

    <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        //{...listeners}
        className="relative group w-32 h-24 border rounded-lg overflow-hidden shadow cursor-grab"
    >

      <img src={url} alt="" {...listeners} className="w-full h-full object-cover" />

      
      <button
        type="button"
        onClick={(e) =>{e.stopPropagation(); onView(url)} }           
        className="absolute top-1 left-1 bg-black/60 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100"
      >
        View
      </button>

      
      <button
        onClick={() => onDelete(id)}             
        className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100"
      >
        ✕
      </button>
    </div>
  );
}

export default function ReorderImages({ urls, onReorder }) {
    const [previewUrl, setPreviewUrl] = useState(null)
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = urls.indexOf(active.id);
    const newIndex = urls.indexOf(over.id);

    onReorder(arrayMove(urls, oldIndex, newIndex));
  };

  const handleDelete = (id) => {
    onReorder(urls.filter((url) => url !== id));
  };

  const handleView = (url) => {
    //window.open(url, "_blank");
    setPreviewUrl(url) 
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={urls} strategy={rectSortingStrategy}>
        <div className="flex gap-4">
          {urls.map((url) => (
            <SortableItem key={url} id={url} url={url} onDelete={handleDelete}  onView={handleView}/>
          ))}
        </div>
        {previewUrl && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50">
            <div className="relative bg-white rounded-lg p-4 max-w-3xl max-h-[90vh]">
                <button
                type="button"
                onClick={() => setPreviewUrl(null)}
                className="absolute top-2 right-2 text-white bg-red-600 rounded-full px-3 py-1"
                >
                ✕
                </button>
                <img
                src={previewUrl}
                alt="preview"
                className="max-w-full max-h-[80vh] rounded-lg"
                />
            </div>
            </div>
        )}
      </SortableContext>
    </DndContext>
  );
}
